<template>
  <div>Edit Sponsors</div>
</template>

<script>
export default {};
</script>